import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../../../../helper/to_dangerous_react_html';
import getTranslatedText from '../../../../../helper/get_translated_text';
import Translation from '../../../../translation/translation';
import formatToCurrency from "../../../../../../_modules/currency/format_to_currency";
import onCrossSellDetailsClick from '../../../../sidebar/actions/on_cross_sell_details_click';
import { CrossSellProductStore } from '../../../../../stores/cross_sell_product_store';

export function Costs(props) {
    const hasWheelAlignment = props.wheelAlignment && props.wheelAlignmentWheelCount;
    const hasShipping = props.totalShipping;
    const shippingClassNames = ['fsf-station-overview__cell'];
    const hasCrossSellProducts = CrossSellProductStore.getState();
    
    let cartProductsPrice = props.productStock.frontendPrice * props.productsQty;
    if (location.href.indexOf('/cart/') !== -1) {
        cartProductsPrice = TYROOLA.initialFluxStates.cartProducts
            ? TYROOLA.initialFluxStates.cartProducts.reduce((price, product) => price + product.priceRaw * product.quantity, 0)
            : props.productStock.frontendPrice * props.productsQty;
    }

    const { shippingWarning } = props;
    const shippingWarningText = shippingWarning && shippingWarning !== '' ? shippingWarning : null;

    if (props.totalShipping.match('free')) {
        shippingClassNames.push('fsf-station-overview__cell--free-shipping-label');
    }

    let tyreCountTrans = <Translation
        translationKey="fitting-station-finder-detail-costs-tyre"
    />;
    if (props.productsQty > 1) {
        tyreCountTrans = <Translation
            translationKey="fitting-station-finder-detail-costs-tyres"
            placeholder={{ tyreCount: props.productsQty }}
        />;
    }
    return (
        <div className="fsf-station__detail">
            <h3 className="fsf-station__detail-headline">
                <Translation translationKey="fitting-station-finder-app-costs" />
            </h3>
            <div className="fsf-station__detail-contents">
                {props.productsPrice && <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                    <div className="fsf-station-overview__cell">
                        {tyreCountTrans}
                        <br />
                        <span style={{ color: 'grey' }}>
                            {(!!props.productManufacturer && props.productModel) && props.productManufacturer + ' ' + props.productModel + ' ' + props.productDimensions}
                        </span>
                    </div>
                    <div className="fsf-station-overview__cell">
                        {formatToCurrency(
                            cartProductsPrice,
                            TYROOLA.globals.currencyIsoCode,
                            true,
                            true
                        )
                        }
                    </div>
                </div>}

                {hasCrossSellProducts && hasCrossSellProducts.filter(csp => csp.preselected).map(csp => (
                    <div key={(csp.spinachId || csp.id)} className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                        <div className="fsf-station-overview__cell">
                            {csp.titleShort}
                            <br />
                            <span className={`cross-sell-product-${(csp.spinachId || csp.id)}`} style={{ color: 'grey' }}>
                                <div
                                    className={csp.lightContentAvailable ? 'underline cursor-pointer' : ''}
                                    onClick={() => csp.lightContentAvailable && onCrossSellDetailsClick(csp)}
                                >{csp.descriptionShort} <svg xmlns="http://www.w3.org/2000/svg" style={{ position: 'relative', top: '3px' }} width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16"> <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" /> <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" /> </svg></div>
                            </span>
                        </div>
                        <div className="fsf-station-overview__cell">
                            <span className="price">
                                {formatToCurrency(
                                    (csp.syncQty ? csp.price * (csp.quantity || props.productsQty) : csp.price),
                                    TYROOLA.globals.currencyIsoCode,
                                    true,
                                    true
                                )}
                            </span>
                        </div>
                    </div>
                ))
                }

                {props.allDiscounts && props.allDiscounts.length > 0 &&
                    <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item" style={{ paddingBottom: '10px' }}>
                        <div className='fsf-station-overview__cell' style={{ paddingBottom: '0', fontWeight: '400' }}>
                            <Translation
                                translationKey="fitting-station-finder-app-discount"
                            />
                        </div>
                        {props.allDiscounts.map(d => (
                            <div key={d.name}>
                                <div className="fsf-station-overview__cell" style={{ padding: '0' }}>
                                    <span style={{ color: 'grey' }}>{d.name}</span>
                                </div>
                                <div className="fsf-station-overview__cell discount__price" style={{ padding: '0' }}>
                                    <span className="price">
                                        {formatToCurrency(d.amount, TYROOLA.globals.currencyIsoCode, true, true)}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                }

                <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                    <div className="fsf-station-overview__cell">
                        <Translation
                            translationKey="fitting-station-finder-detail-costs-fitting"
                        />
                    </div>
                    <div className="fsf-station-overview__cell">
                        <div dangerouslySetInnerHTML={toDangerousReactHtml(props.fittingCosts)} />
                    </div>
                </div>


                {hasShipping &&
                    <>
                        <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                            <div className={shippingClassNames.join(' ')}>
                                <Translation
                                    translationKey="fitting-station-finder-detail-costs-shipping"
                                />
                            </div>
                            <div className="fsf-station-overview__cell" dangerouslySetInnerHTML={toDangerousReactHtml(props.totalShipping)} />
                        </div>
                        {shippingWarningText && <p className="text-danger">{shippingWarningText}</p>}
                    </>
                }

                {hasWheelAlignment
                    && props.wheelAlignment2IsShowable
                    && props.wheelAlignmentWheelCount === 2
                    &&
                    <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                        <div className="fsf-station-overview__cell">
                            <Translation
                                className="fsf-station-overview__wheel-alignment-label"
                                translationKey="fitting-station-finder-details-costs-summary-wheel-alignment-label"
                                placeholder={{ wheelCount: props.wheelAlignmentWheelCount }}
                            />
                            {' '}
                            <span
                                className="fsf-station-overview__remove-wheel-alignment"
                                onClick={evt => {
                                    evt.stopPropagation();
                                    props.onWheels2Change();
                                }}
                            >
                                Remove
                            </span>
                        </div>
                        <div className="fsf-station-overview__cell">
                            <div dangerouslySetInnerHTML={toDangerousReactHtml(props.wheelAlignment)} />
                        </div>
                    </div>
                }

                {hasWheelAlignment
                    && props.wheelAlignment4IsShowable
                    && props.wheelAlignmentWheelCount !== 2
                    &&
                    <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                        <div className="fsf-station-overview__cell">
                            <Translation
                                className="fsf-station-overview__wheel-alignment-label"
                                translationKey="fitting-station-finder-details-costs-summary-wheel-alignment-label"
                                placeholder={{ wheelCount: props.wheelAlignmentWheelCount }}
                            />
                            {' '}
                            <span
                                className="fsf-station-overview__remove-wheel-alignment"
                                onClick={evt => {
                                    evt.stopPropagation();
                                    props.onWheels4Change();
                                }}
                            >
                                Remove
                            </span>
                        </div>
                        <div className="fsf-station-overview__cell">
                            <div dangerouslySetInnerHTML={toDangerousReactHtml(props.wheelAlignment)} />
                        </div>
                    </div>
                }

                {props.calloutFee &&
                    <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                        <div className="fsf-station-overview__cell">
                            Call-out fee
                            <br />
                            <Translation
                                translationKey="fitting-station-finder-app-callout-fee-disclaimer"
                                className="service-callout-fee__disclaimer"
                                key="FsfServiceCalloutFeeDisclaimer"
                            />
                        </div>
                        <div className="fsf-station-overview__cell">
                            <div dangerouslySetInnerHTML={toDangerousReactHtml(props.calloutFee)} />
                        </div>
                    </div>
                }

                <div className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--totals">
                    <div className="fsf-station-overview__cell">
                        <Translation
                            translationKey="fitting-station-finder-detail-costs-total"
                        />
                    </div>
                    <div className="fsf-station-overview__cell">
                        <span dangerouslySetInnerHTML={toDangerousReactHtml(props.totalCart)} />
                    </div>
                </div>
            </div>
        </div>
    );
}

Costs.propTypes = {
    wheelAlignment: PropTypes.string.isRequired,
    wheelAlignmentWheelCount: PropTypes.number.isRequired,
    totalShipping: PropTypes.string.isRequired,
    calloutFee: PropTypes.string,
    totalCart: PropTypes.string.isRequired,
    onWheels2Change: PropTypes.func.isRequired,
    onWheels4Change: PropTypes.func.isRequired,
    tyreBrand: PropTypes.string,
    isMarketplaceSeller: PropTypes.bool,
    productStock: PropTypes.object,
    productsQty: PropTypes.number,
    buy4Pay3: PropTypes.bool,
    shippingWarning: PropTypes.string,
};

Costs.defaultProps = {
    calloutFee: '',
    tyreBrand: '',
    isMarketplaceSeller: false,
    productStock: null,
    productsQty: 0,
    buy4Pay3: false,
};
